<template>
    <v-card flat tile min-height="380" class="folders-tree-card" style="height: 100% !important; flex-grow: 0 !important" role="region" aria-label="Project Folders">
        <v-card-text class="pa-2 pb-0">
            <v-row class="my-2">
                <v-col class="pt-1 pb-3 px-4">
                    <v-text-field
                        v-model="foldersearch"
                        rounded
                        dense
                        filled
                        prepend-inner-icon="mdi-magnify"
                        label="Search folders"
                        :aria-controls="'folders_table'"
                        type="search"
                        clearable
                        hide-details
                        autocomplete="off"
                        @click:clear="foldersearch = ''">
                    </v-text-field>
                </v-col>
            </v-row>

            <v-chip v-if="foldersearch.length" small class="ml-2">{{ resultsStatus }}</v-chip>

            <div class="flex mb-1 mt-2">
                <div>
                    <v-btn :disabled="!canEdit" small color="primary" class="pl-3" text @click="openCreateDialog">
                        <v-icon small color="primary" class="pr-2">mdi-folder-plus-outline</v-icon>
                        New Folder
                    </v-btn>
                </div>
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn text v-bind="attrs" v-on="on" class="ml-auto" color="primary" small>Sort by</v-btn>
                    </template>
                    <v-list rounded dense flat>
                        <v-list-item @click="folder_sort_by = ['_id']" class="pl-2">
                            <v-list-item-title>Created Date</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="folder_sort_by = ['projects.length']" class="pl-2">
                            <v-list-item-title>Projects Count</v-list-item-title>
                        </v-list-item>
                        <v-list-item class="pl-2" @click="folder_sort_by = ['name']">
                            <v-list-item-title>Title</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn @click="folder_sort_desc = folder_sort_desc[0] ? [false] : [true]" color="primary" small icon>
                    <v-icon v-if="folder_sort_desc[0] === false" small>mdi-sort-ascending</v-icon>
                    <v-icon v-else small>mdi-sort-descending</v-icon>
                </v-btn>
            </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-dialog v-model="dialog.show" max-width="500px" transition="slide-x-transition" hide-details @click:outside="dialog.show = false">
            <v-card>
                <div class="backsheet"></div>
                <v-btn class="close-btn" absolute top right icon color="primary" @click="dialog.show = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-card-text class="pt-5 pb-0">
                    <div class="quarolbl pb-1">Folder name</div>
                    <v-text-field class="my-2" label="Folder name" rounded filled v-model="folderTitle"></v-text-field>
                    <div class="lbl pb-1">Select projects</div>
                    <v-autocomplete label="Search projects" filled rounded v-model="selectedFolderProjects" :items="projects" item-text="title" item-value="_id" chips deletable-chips multiple>
                    </v-autocomplete>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="mx-auto" color="primary" @click="editFolder ? editFolderItem() : createFolder()" rounded>
                        {{ editFolder ? "Save" : "Create" }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="manageFolderProjects" max-width="500px" transition="slide-x-transition" hide-details @click:outside="manageFolderProjects = false">
            <v-card>
                <div class="backsheet"></div>
                <v-btn class="close-btn" absolute top right icon color="primary" @click="manageFolderProjects = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-card-text class="pt-5 pb-0">
                    <div class="quarolbl pb-1">Manage projects</div>
                    <v-autocomplete label="Search projects" filled rounded v-model="selectedFolderProjects" :items="projects" item-text="title" item-value="_id" chips deletable-chips multiple>
                    </v-autocomplete>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="mx-auto" color="primary" @click="updateFolderProjects" rounded>Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <DeleteDialog
            :deleteDialog="deleteDialog.show"
            :selectedDeleteItem="selectedDeleteItem ? selectedDeleteItem.name : ''"
            deleteLabel="Folder"
            :loading="deleteDialog.loading"
            @delete="deleteFolderItem(selectedDeleteItem._id)"
            @close="deleteDialog.show = false">
        </DeleteDialog>

        <div class="pb-2 px-0">
            <v-data-table
                hide-default-footer
                hide-default-header
                id="folders_table"
                ref="foldersTable"
                :headers="headers"
                :items="folders"
                item-key="id"
                no-data-text="No folders yet"
                :item-class="itemBackground"
                @click:row="onRowClick"
                :search.sync="foldersearch"
                class="row-pointer"
                :sort-by.sync="folder_sort_by"
                :sort-desc.sync="folder_sort_desc"
                :items-per-page.sync="folder_items_per_page">
                <template v-slot:item.name="{ item }">
                    <v-list-item two-line class="px-0" tabindex="0">
                        <v-list-item-avatar class="folder-avatar" :style="'background-color: #edeff1'">
                            <v-icon class="folder-avatar-icon">{{ item.active ? "mdi-folder-open" : "mdi-folder" }}</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content style="color: #666666" class="folder-list-content">
                            <v-list-item-title class="folder-title" style="font-size: 15px">{{ item.name }}</v-list-item-title>
                            <v-list-item-subtitle>
                                <div style="display: flex">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                @click.stop="canEdit ? manageProjects(item) : null"
                                                :color="'#edeff1'"
                                                class="px-2 mr-1 qchip folder-btn"
                                                :text="item.active ? true : false"
                                                x-small
                                                elevation="0"
                                                fab
                                                height="20px"
                                                min-width="40px"
                                                rounded
                                                v-on="on">
                                                <v-icon class="mr-1" x-small>mdi-file-multiple-outline</v-icon>
                                                {{ item.projects ? item.projects.length : 0 }}
                                            </v-btn>
                                        </template>
                                        <span>{{ item.projects ? item.projects.length : 0 }} assigned projects</span>
                                    </v-tooltip>

                                    <v-menu :disabled="!canEdit" offset-y rounded="lg" transition="slide-y-transition" bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                v-on="on"
                                                @click.stop
                                                :color="item.active ? 'white' : '#edeff1'"
                                                class="mr-1 folder-btn"
                                                :text="item.active ? true : false"
                                                x-small
                                                elevation="0"
                                                rounded
                                                fab
                                                width="20px"
                                                height="20px">
                                                <v-icon :color="item.active ? 'white' : ''" x-small>mdi-dots-vertical</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list rounded dense>
                                            <v-list-item
                                                @click.stop="
                                                    editFolder = true
                                                    folderTitle = item.name
                                                    selectedFolderProjects = item.projects || []
                                                    editItem = item
                                                    dialog.show = true
                                                ">
                                                <v-icon small class="mr-2">mdi-pencil</v-icon><v-list-item-title>Edit</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item
                                                @click.stop="
                                                    selectedDeleteItem = item
                                                    deleteDialog.show = true
                                                ">
                                                <v-icon small class="mr-2">mdi-delete</v-icon><v-list-item-title>Delete</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-data-table>
        </div>
    </v-card>
</template>

<script>
    import DeleteDialog from "../../components/dialogs/DeleteDialog.vue"

    export default {
        name: "MonitoringFolderBar",
        props: {
            projects: {
                type: Array,
                default: () => []
            },
            companyId: {
                type: String,
                default: ""
            },
            canEdit: {
                type: Boolean,
                default: true
            },
            clearSelection: {
                type: Number,
                default: 0
            }
        },
        components: {
            DeleteDialog
        },
        data: () => ({
            deleteDialog: { show: false, loading: false },
            selectedDeleteItem: null,
            folders: [],
            manageFolder: {},
            manageFolderProjects: false,
            editFolder: false,
            editItem: {},
            selectedFolderProjects: [],
            folder_sort_desc: [true],
            folder_sort_by: ["name"],
            folder_items_per_page: -1,
            foldersearch: "",
            headers: [
                { text: "Folder", align: "start", sortable: true, value: "name" },
                {
                    text: "Created",
                    align: " d-none",
                    sortable: true,
                    sort: (a, b) => {
                        try {
                            const date1 = new Date(parseInt(a.toString().slice(0, 8), 16) * 1000)
                            const date2 = new Date(parseInt(b.toString().slice(0, 8), 16) * 1000)
                            return date1 - date2
                        } catch (error) {
                            return 1
                        }
                    },
                    value: "_id"
                },
                { text: "Projects", align: " d-none", sortable: true, value: "projects.length" },
                { text: "", value: "actions", sortable: false }
            ],
            folderTitle: "",
            dialog: { show: false }
        }),
        computed: {
            existingProjectIds() {
                return new Set((this.projects || []).map((p) => p._id))
            },
            resultsCount() {
                const t = this.$refs.foldersTable
                if (t && Array.isArray(t.filteredItems)) return t.filteredItems.length
                const all = this.folders || []
                const q = (this.foldersearch || "").trim().toLowerCase()
                if (!q) return all.length
                return all.filter((f) => (f.name || "").toLowerCase().includes(q)).length
            },
            resultsStatus() {
                const n = this.resultsCount
                if (!this.foldersearch) return `${n} folder${n === 1 ? "" : "s"}`
                return `${n} result${n === 1 ? "" : "s"} for "${this.foldersearch}"`
            }
        },
        watch: {
            clearSelection() {
                this.folders = (this.folders || []).map((f) => ({ ...f, active: false }))
            },
            projects: {
                deep: true,
                handler() {
                    this.sanitizeFolders()
                }
            }
        },
        methods: {
            getMonitoringApiBase() {
                const companyId = this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                return JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(companyId) == -1 ? process.env.VUE_APP_MONITORING_API_URL : process.env.VUE_APP_APIURL + "/monitoring-api"
            },
            async fetchFolder() {
                try {
                    const url = this.getMonitoringApiBase() + "/project/folders/get"
                    const post_data = {
                        company_id: localStorage.company_id
                    }
                    const response_data = await this.$helpers.axiosPost(url, post_data)
                    this.folders = (response_data.data.folders || []).map((f) => ({
                        ...f,
                        active: false,
                        projects: Array.isArray(f.projects) ? f.projects : []
                    }))
                    this.sanitizeFolders(false)
                } catch (error) {
                    console.log(error)
                    this.folders = []
                }
            },
            sanitizeFolders(emitSelection = true) {
                // Avoid deleting assignments on initial mount before projects are fetched.
                if (!Array.isArray(this.projects) || this.projects.length === 0) {
                    if (emitSelection) {
                        const activeFolder = this.folders.find((f) => f.active)
                        if (activeFolder) this.$emit("folderSelect", activeFolder)
                    }
                    return
                }

                let changed = false
                this.folders = (this.folders || []).map((f) => {
                    const sanitizedProjects = (Array.isArray(f.projects) ? f.projects : []).filter((id) => this.existingProjectIds.has(id))
                    if ((f.projects || []).length !== sanitizedProjects.length) changed = true
                    return { ...f, projects: sanitizedProjects }
                })

                if (changed) {
                    this.folders.forEach((folder) => {
                        this.updateFolderProjects(folder)
                    })
                }

                if (emitSelection) {
                    const activeFolder = this.folders.find((f) => f.active)
                    if (activeFolder) this.$emit("folderSelect", activeFolder)
                }
            },
            openCreateDialog() {
                this.editFolder = false
                this.editItem = {}
                this.folderTitle = ""
                this.selectedFolderProjects = []
                this.dialog.show = true
            },
            manageProjects(item) {
                this.manageFolder = item
                this.manageFolderProjects = true
                this.selectedFolderProjects = Array.isArray(item.projects) ? [...item.projects] : []
            },
            async updateFolderProjects(explicitFolder = null) {
                const folderToUpdate = explicitFolder || this.manageFolder
                if (!folderToUpdate || !folderToUpdate._id) return

                if (!explicitFolder) {
                    folderToUpdate.projects = [...new Set(this.selectedFolderProjects)]
                }

                const index = this.folders.findIndex((x) => x._id === folderToUpdate._id)
                if (index > -1) {
                    this.$set(this.folders, index, { ...folderToUpdate })

                    const url = this.getMonitoringApiBase() + "/project/folders/update"
                    const post_data = {
                        company_id: localStorage.company_id,
                        folder: {
                            ...this.folders[index],
                            projects: Array.isArray(this.folders[index].projects) ? [...new Set(this.folders[index].projects)] : []
                        }
                    }
                    await this.$helpers.axiosPost(url, post_data)

                    if (this.folders[index].active) this.$emit("folderSelect", this.folders[index])
                }
                this.manageFolderProjects = false
            },
            async createFolder() {
                if (!this.folderTitle || !this.folderTitle.trim()) return
                const newFolder = {
                    name: this.folderTitle.trim(),
                    projects: [...new Set(this.selectedFolderProjects)]
                }

                const url = this.getMonitoringApiBase() + "/project/folders/add"
                const post_data = {
                    company_id: localStorage.company_id,
                    folder: newFolder
                }
                await this.$helpers.axiosPost(url, post_data)

                this.dialog.show = false
                this.folderTitle = ""
                this.selectedFolderProjects = []
                await this.fetchFolder()
            },
            async editFolderItem() {
                if (!this.editItem || !this.editItem._id) return
                const index = this.folders.findIndex((x) => x._id === this.editItem._id)
                if (index > -1) {
                    this.$set(this.folders, index, {
                        ...this.folders[index],
                        name: this.folderTitle,
                        projects: [...new Set(this.selectedFolderProjects)]
                    })
                    await this.updateFolderProjects(this.folders[index])
                }
                this.dialog.show = false
                this.editFolder = false
            },
            async deleteFolderItem(_id) {
                const index = this.folders.findIndex((x) => x._id === _id)
                const wasActive = index > -1 ? this.folders[index].active : false

                if (index > -1) {
                    const url = this.getMonitoringApiBase() + "/project/folders/delete"
                    const post_data = {
                        company_id: localStorage.company_id,
                        folder: this.folders[index]
                    }
                    await this.$helpers.axiosPost(url, post_data)
                }

                this.deleteDialog.show = false
                await this.fetchFolder()
                if (wasActive) this.$emit("folderSelect", null)
            },
            itemBackground(item) {
                if (!item) return ""
                return item.active ? "itemactive2" : ""
            },
            onRowClick(item) {
                if (!item.active) {
                    this.folders = this.folders.map((f) => ({ ...f, active: f._id === item._id }))
                    this.$emit(
                        "folderSelect",
                        this.folders.find((f) => f._id === item._id)
                    )
                } else {
                    this.folders = this.folders.map((f) => ({ ...f, active: false }))
                    this.$emit("folderSelect", null)
                }
            }
        },
        mounted() {
            this.fetchFolder()
        }
    }
</script>

<style scoped>
    .itemactive2 {
        background: var(--v-primary-base) !important;
        color: white !important;
    }
    .itemactive2 .folder-title {
        color: white !important;
    }
    .folders-tree-card {
        height: 100%;
    }
    .row-pointer >>> tbody tr:hover {
        cursor: pointer;
    }
    .text-start {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
    table > tbody > tr > td:nth-child(1) {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
    .theme--dark .folder-list-content {
        color: white !important;
    }
    .theme--dark .folder-avatar {
        background-color: rgb(0, 0, 0) !important;
    }
    .theme--dark .folder-avatar-icon {
        color: rgb(112, 112, 112) !important;
    }
    .theme--dark .folder-btn {
        background-color: rgb(112, 112, 112) !important;
    }
</style>
